import { render, staticRenderFns } from "./PostProcessReturnButton.vue?vue&type=template&id=1e6b8d62&"
import script from "./PostProcessReturnButton.vue?vue&type=script&lang=js&"
export * from "./PostProcessReturnButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports